import { render, staticRenderFns } from "./ModalDocumentTypeEdit.vue?vue&type=template&id=d8a0eddc&"
import script from "./ModalDocumentTypeEdit.vue?vue&type=script&lang=js&"
export * from "./ModalDocumentTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports